<div class="outer-container">
    <lib-action-button
        largeButton
        [label]="label"
        [disabled]="disabled">
    </lib-action-button>
</div>
